import React from 'react'
import MainGrid from './Components/MainGrid'

function PatientDietPage() {
  return (
    <MainGrid />
  )
}

export default PatientDietPage